import React from 'react'
import { FirebaseHelper } from '../../firebase-helper';
import { comment } from '../../utility/comment-utility';
import './CommentForm.scss'

function CommentForm(props) {
    

    const sendComment = (e) => {
        e.preventDefault();
        const newComment = comment();
        newComment.nickname = e.target[0].value;
        newComment.comment = e.target[1].value;

        FirebaseHelper.addComment(props.id, newComment);
        console.log("Comment Sended");
        e.target[0].value = "";
        e.target[1].value = "";
    }
    return (
        <div className='post-comment-form-container'>
            <form onSubmit={sendComment}>
                <span>Your Nickname</span>
                <input type="text" />
                <span>Your Comment</span>
                <textarea></textarea>
                <button>Send </button>
            </form>
        </div>
    )
}

export default CommentForm